import React from 'react';
import { FileBadge2, Ban } from 'lucide-react';

/** Ask whether the patient also needs a credit / cashless facilitation letter. */
export default function CreditLetterFields({ needsCreditLetter, setNeedsCreditLetter }) {
  return (
    <section className="space-y-4" data-testid="credit-letter-section">
      <div>
        <h2 className="font-heading text-xl text-stone-900">Credit letter</h2>
        <p className="text-sm text-stone-500">
          A credit letter helps the destination hospital extend cashless / credit facilities
          against campus or employer arrangements, where applicable.
        </p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <Choice
          active={needsCreditLetter === true}
          onClick={() => setNeedsCreditLetter(true)}
          icon={FileBadge2}
          title="Yes, I need a credit letter"
          body="Include a request for credit / cashless facilitation with this referral."
          testId="credit-letter-yes"
        />
        <Choice
          active={needsCreditLetter === false}
          onClick={() => setNeedsCreditLetter(false)}
          icon={Ban}
          title="No credit letter"
          body="Only the clinical referral letter is required for this request."
          testId="credit-letter-no"
        />
      </div>
      {needsCreditLetter === true && (
        <div className="rounded-2xl border border-sky-200 bg-sky-50 px-4 py-3 text-sm text-sky-950">
          <strong>Noted.</strong> Approvers and the campus doctor will see that a credit letter
          is requested along with the clinical referral.
        </div>
      )}
    </section>
  );
}

function Choice({ active, onClick, icon: Icon, title, body, testId }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`rounded-2xl border px-4 py-4 text-left transition ${
        active
          ? 'border-[var(--brand)] bg-orange-50 shadow-sm'
          : 'border-stone-200 bg-white hover:border-stone-300'
      }`}
    >
      <div className="mb-2 flex items-center gap-2">
        <span className={`rounded-full p-2 ${active ? 'bg-white text-[var(--brand)]' : 'bg-stone-100 text-stone-600'}`}>
          <Icon className="h-4 w-4" />
        </span>
        <p className="font-semibold text-stone-900">{title}</p>
      </div>
      <p className="text-xs leading-relaxed text-stone-500">{body}</p>
    </button>
  );
}
